import { connect } from 'react-redux';
import { exercisePropTypes } from '../../../constants/exercise';
import propTypes from 'prop-types';
import { SharedTextContent } from './components';
import { SOURCES } from '../../../constants/sources';
import { get } from 'lodash';
import { replaceWithAbsolutePath } from '../../../lib/media-path-replacer';

export const SharedText = ({
    exercise,
    answers = exerciseDefaultProps.answers,
    onAnswer,
    showModal,
    correctionStatus,
    onPlayVideo,
    videos,
    show,
    hasAttachments = exerciseDefaultProps.hasAttachments,
    hintBoxIsOpen,
    toggleHintBox,
    source,
}) => {
    const isUnitutor = source === SOURCES.ZTE_UNITUTOR;
    const title = isUnitutor ? get(exercise, 'name') : get(exercise, 'publicTitle');
    const publicTitle = get(exercise, 'publicTitle');
    const content = replaceWithAbsolutePath(get(exercise, 'json.question'));

    return (
        <SharedTextContent
            title={title}
            publicTitle={publicTitle}
            content={content}
            showExpandButton={true}
            isUnitutor={isUnitutor}
            isDefaultOpen={true}
        />
    );
};

SharedText.prototypes = {
    ...exercisePropTypes,
    source: propTypes.string,
};

const mapStateToProps = (state) => {
    return {
        source: state.application.source,
    };
};

export default connect(mapStateToProps)(SharedText);
